import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { SendingChannelType } from "./SendingChannelType";

export interface PortalMessageRecipient {
    id: number;
    messageId: number;
    recipientRole: number;
    recipientContact: string;
    recipientInfo: string;
    portalUserId:string,
    portalUserName:string,
    isReadConfirmationRequired:boolean,
    readConfirmationSent?: string;
    readDate?: Date;
    isDisabledPortalUser?: boolean;
}

export class PortalMessageRecipientFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, messageRecipient: PortalMessageRecipient, channel:SendingChannelType) {
  
        const contactValidators = [];
        const portalUserValidators = [];
        if(channel == SendingChannelType.Sms){
            contactValidators.push(Validators.pattern("^[0-9- ]*$"));
            contactValidators.push(Validators.required);
        }

        if(channel == SendingChannelType.Email){
            contactValidators.push(Validators.email);
            contactValidators.push(Validators.required);
        }

        if(channel == SendingChannelType.Portal){
            portalUserValidators.push(Validators.required);
        }

      return fb.group(
        {
          recipientRole: [messageRecipient.recipientRole,[Validators.required,Validators.min(1)]],
          recipientContact: [messageRecipient.recipientContact,contactValidators],
          recipientInfo:[messageRecipient.recipientInfo],
          portalUserId:[messageRecipient.portalUserId,portalUserValidators],
          portalUserName:[messageRecipient.portalUserName, portalUserValidators],
          isReadConfirmationRequired:[messageRecipient.isReadConfirmationRequired],
          isDisabledPortalUser:[messageRecipient.isDisabledPortalUser],
        });
    }
    
    static initPortalMessageRecipient(): PortalMessageRecipient {

        return {
            id: 0,
            messageId: 0,
            recipientRole: 0,
            recipientContact: '',
            recipientInfo:'',
            portalUserId:null,
            portalUserName:'',
            isReadConfirmationRequired:false,
            isDisabledPortalUser:false,
            readDate: null
        };
    }
}